import React from 'react';

import InfoMessage from '@modules/common/components/banners/InfoMessage';
import TargetBlankLink from '@src/components/common/TargetBlankLink';

function PIPBanner() {
  return (
    <div style={{ margin: '1rem' }}>
      <InfoMessage
        icon="bell outline"
        header="Important update"
        content={
          <>
            Sentinel Hub Dashboard is getting an upgrade - use{' '}
            <TargetBlankLink href="http://insights.planet.com/">
              Planet Insights Platform
            </TargetBlankLink>{' '}
            to get all the features.
          </>
        }
      />
    </div>
  );
}

export default PIPBanner;
